import React, { ReactNode } from 'react';
import { type AvatarProps, Stack, type SxProps, Typography } from '@mui/material';

import { type User } from '@/api/generated';
import { UserAvatar } from '@/components/UserAvatar';
import { getUserFullName } from '@/utils/user';

type UserCellProps = {
  children?: ReactNode;
  avatarVariant?: AvatarProps['variant'];
  sx?: SxProps;
} & Pick<User, 'firstName' | 'lastName' | 'fullName' | 'avatarUrl'>;

const UserCell = ({
  avatarUrl,
  firstName,
  lastName,
  fullName,
  children,
  avatarVariant = 'user-small',
  sx
}: UserCellProps) => {
  const name = getUserFullName({ firstName, lastName, fullName });

  return (
    <Stack
      gap={1.25}
      direction="row"
      alignItems="center"
      padding={2}
      sx={{
        '&:visited': { color: 'inherit' },
        ...sx
      }}
    >
      <UserAvatar
        firstName={firstName}
        lastName={lastName}
        fullName={fullName}
        avatarUrl={avatarUrl}
        variant={avatarVariant}
      />
      <Typography variant="body2" sx={{ whiteSpace: 'nowrap', 'a:hover &': { textDecoration: 'underline' } }}>
        {name}
      </Typography>
      {children}
    </Stack>
  );
};

export default UserCell;
